import { render, staticRenderFns } from "./commodity_free_rule.vue?vue&type=template&id=773d887b&scoped=true"
import script from "./commodity_free_rule.vue?vue&type=script&lang=js"
export * from "./commodity_free_rule.vue?vue&type=script&lang=js"
import style0 from "./commodity_free_rule.vue?vue&type=style&index=0&id=773d887b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773d887b",
  null
  
)

export default component.exports